import { Skeleton } from "@/components/ui/skeleton"
export const DashboardChartSkeleton = () => {
  return (
    <div className="flex h-[150px] w-full items-center justify-center">
      <Skeleton className="flex size-28 items-center justify-center rounded-full">
        <div className="flex size-[70px] items-center justify-center rounded-full bg-card">
          <Skeleton className="h-8 w-10" />
        </div>
      </Skeleton>
    </div>
  )
}
